module.exports = __webpack_public_path__ + "img/lampOff.330463ad.svg";